import { DatosGenerales } from '../Models/datosGenerales';
import { DatosPlanes } from '../Models/datosPlanes';

export const getVehicleData = (datosGenerales: DatosGenerales | null | undefined) => {
  // Procesando datos del vehículo para el dataLayer
  return {
    zona_circulacion: datosGenerales?.Lead?.cityName || '',
    uso_vehiculo:
      datosGenerales?.LeadResponse?.data?.vehicle?.use_type ||
      datosGenerales?.Lead?.use_type ||
      'Particular',
    placa:
      datosGenerales?.LeadResponse?.data?.vehicle?.plate ||
      datosGenerales?.Lead?.plate ||
      '',
    marca_vehiculo: datosGenerales?.LeadResponse?.data?.vehicle?.brand || '',
    modelo_vehiculo: datosGenerales?.LeadResponse?.data?.vehicle?.model || '',
    cilindraje_vehiculo: datosGenerales?.LeadResponse?.data?.vehicle?.cylinder || '',
  };
};

export const getPlanesData = (planes: DatosPlanes | null | undefined) => {
  const dataPlan = planes?.planes?.data?.products.find(
    (plan) => plan.code === planes?.selected_plan,
  );

  const valor_plan =
    planes?.payment_frequency === 'Annually'
      ? dataPlan?.priceAnual.amount
      : dataPlan?.priceMensual.amount;
  return {
    plan_seleccionado: planes?.selected_plan || '',
    periodicidad_pago: planes?.payment_frequency || '',
    valor_plan,
  };
};

export const getInactivityData = (data: DatosGenerales | null | undefined) => {
  return {
    name: data?.Lead?.name || '',
    mobile_phone: data?.Lead?.mobile_phone || '',
    plate: data?.Lead?.plate || '',
  };
};
